var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Invite"},[_c('banner',{attrs:{"img":"../assets/img/bgtop.jpg","title":"招贤纳士"}}),_c('div',{staticClass:"Invite-product"},[_c('div',{staticClass:"Invite-product-content"},[_c('div',{staticClass:"editor-content",domProps:{"innerHTML":_vm._s(_vm.content)}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }